import * as Yup from 'yup';

Yup.setLocale({
  string: {
    url: 'Please provide a valid URL that includes http://',
  },
});
